(() => {
  const MIN_DESKTOP_WIDTH = 990;
  const ZOOM_RATIO = 2.35;
  const PANEL_GAP = 18;
  const PANEL_MAX_SIZE = 680;
  const PANEL_MIN_SIZE = 360;
  const PANEL_SCALE = 1.25;
  const desktopQuery = window.matchMedia(`(min-width: ${MIN_DESKTOP_WIDTH}px) and (hover: hover) and (pointer: fine)`);

  let pane = null;
  let active = null;

  function getPane() {
    if (pane) return pane;

    pane = document.createElement('div');
    pane.className = 'stonylab-magnifier-pane';
    pane.setAttribute('aria-hidden', 'true');
    document.body.appendChild(pane);
    return pane;
  }

  function getLargestImageUrl(image) {
    if (!image) return '';

    const candidates = (image.srcset || '')
      .split(',')
      .map((item) => item.trim().match(/^(.*)\s+(\d+)w$/))
      .filter(Boolean)
      .map((match) => ({ url: match[1], width: Number(match[2]) }))
      .sort((a, b) => b.width - a.width);

    return candidates[0]?.url || image.currentSrc || image.src;
  }

  function getPointerPosition(event, rect) {
    return {
      x: Math.min(Math.max(event.clientX - rect.left, 0), rect.width),
      y: Math.min(Math.max(event.clientY - rect.top, 0), rect.height),
    };
  }

  function getPanelRect(imageRect) {
    const viewportPadding = 16;
    const rightSpace = window.innerWidth - imageRect.right - PANEL_GAP - viewportPadding;
    const leftSpace = imageRect.left - PANEL_GAP - viewportPadding;
    const showOnRight = rightSpace >= PANEL_MIN_SIZE || rightSpace >= leftSpace;
    const availableWidth = Math.max(PANEL_MIN_SIZE, showOnRight ? rightSpace : leftSpace);
    const width = Math.min(PANEL_MAX_SIZE, availableWidth, Math.max(imageRect.width * PANEL_SCALE, PANEL_MIN_SIZE));
    const height = Math.min(PANEL_MAX_SIZE, imageRect.height * PANEL_SCALE, window.innerHeight - viewportPadding * 2);
    const left = showOnRight ? imageRect.right + PANEL_GAP : imageRect.left - PANEL_GAP - width;
    const top = Math.min(Math.max(imageRect.top, viewportPadding), window.innerHeight - height - viewportPadding);

    return { left, top, width, height };
  }

  function showMagnifier(opener, event) {
    if (!desktopQuery.matches || event.pointerType !== 'mouse') return;

    const image = opener.querySelector('.product__media img');
    const media = opener.querySelector('.product__media') || opener;
    if (!image || !media) return;

    const imageUrl = getLargestImageUrl(image);
    if (!imageUrl) return;

    active = {
      opener,
      image,
      media,
      lens: getLens(opener),
      pane: getPane(),
    };

    active.pane.style.backgroundImage = `url("${imageUrl.replace(/"/g, '\\"')}")`;
    active.pane.classList.add('is-visible');
    active.lens.classList.add('is-visible');
    updateMagnifier(event);
  }

  function getLens(opener) {
    let lens = opener.querySelector(':scope > .stonylab-magnifier-lens');
    if (lens) return lens;

    lens = document.createElement('div');
    lens.className = 'stonylab-magnifier-lens';
    lens.setAttribute('aria-hidden', 'true');
    opener.appendChild(lens);
    return lens;
  }

  function updateMagnifier(event) {
    if (!active || !desktopQuery.matches) return;

    const imageRect = active.media.getBoundingClientRect();
    if (!imageRect.width || !imageRect.height) return;

    const panelRect = getPanelRect(imageRect);
    const point = getPointerPosition(event, imageRect);
    const lensWidth = Math.min(panelRect.width / ZOOM_RATIO, imageRect.width);
    const lensHeight = Math.min(panelRect.height / ZOOM_RATIO, imageRect.height);
    const lensLeft = Math.min(Math.max(point.x - lensWidth / 2, 0), imageRect.width - lensWidth);
    const lensTop = Math.min(Math.max(point.y - lensHeight / 2, 0), imageRect.height - lensHeight);
    const backgroundWidth = imageRect.width * ZOOM_RATIO;
    const backgroundHeight = imageRect.height * ZOOM_RATIO;
    const backgroundLeft = Math.min(
      Math.max(panelRect.width / 2 - point.x * ZOOM_RATIO, panelRect.width - backgroundWidth),
      0
    );
    const backgroundTop = Math.min(
      Math.max(panelRect.height / 2 - point.y * ZOOM_RATIO, panelRect.height - backgroundHeight),
      0
    );

    active.lens.style.width = `${lensWidth}px`;
    active.lens.style.height = `${lensHeight}px`;
    active.lens.style.transform = `translate(${lensLeft}px, ${lensTop}px)`;

    active.pane.style.left = `${panelRect.left}px`;
    active.pane.style.top = `${panelRect.top}px`;
    active.pane.style.width = `${panelRect.width}px`;
    active.pane.style.height = `${panelRect.height}px`;
    active.pane.style.backgroundSize = `${backgroundWidth}px ${backgroundHeight}px`;
    active.pane.style.backgroundPosition = `${backgroundLeft}px ${backgroundTop}px`;
  }

  function hideMagnifier() {
    if (!active) return;

    active.lens.classList.remove('is-visible');
    active.pane.classList.remove('is-visible');
    active = null;
  }

  function setupMagnifier(root = document) {
    root.querySelectorAll('.product__modal-opener--image').forEach((opener) => {
      if (opener.dataset.stonylabMagnifier === 'true') return;
      opener.dataset.stonylabMagnifier = 'true';
      opener.addEventListener('pointerenter', (event) => showMagnifier(opener, event));
      opener.addEventListener('pointermove', updateMagnifier);
      opener.addEventListener('pointerleave', hideMagnifier);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupMagnifier());
  } else {
    setupMagnifier();
  }

  document.addEventListener('shopify:section:load', (event) => setupMagnifier(event.target));
  window.addEventListener('resize', hideMagnifier);
  window.addEventListener('scroll', hideMagnifier, true);
})();
